<template>
  <div>
    <el-row class="version-card">
      <el-input
        v-model="input"
        size="small"
        clearable
        style="width: 300px;"
        placeholder="请输入用户编号"
      >
      </el-input>
      <el-button size="small" class="ml-40" type="primary" @click="adlogin">
        确认登录
      </el-button>
    </el-row>
  </div>
</template>

<script>
import * as adLogin from "@/api/adLogin";
export default {
  name: "qhzh",
  computed: {},
  data() {
    return {
      input: "",
    };
  },
  watch: {},
  methods: {
    adlogin() {
      let params = {
        userid: this.input,
      };
      adLogin.getAdLoginUrl(params).then((res) => {
        window.open(res.data.data,"_blank");
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.version-card {
  padding: 30px;
  margin-bottom: 30px;
  background-color: #fff;
}
</style>
